module.exports = __webpack_public_path__ + "img/banner_9.ee133a19.jpg";